import { FC } from "react";
import LensIcon from "@mui/icons-material/Lens";
import { Stack, Typography } from "@mui/material";
import useFetchStructureData from "src/Pages/Company/OrganizationStructure/api/useFetchStructureData";
import __ from "src/utils/Translations";
import { AxiosError } from "axios";
import { useLogStatus } from "src/Pages/Company/OrganizationStructure/utils/NewRelicReporter/useLogStatus/useLogStatus";
import { NewRelicLogLevel } from "src/Pages/Company/OrganizationStructure/utils/NewRelicReporter/useLogStatus/useLogStatus.models";

interface IHeaderInfo {
  companyId: string;
  structureId: string;
}

const HeaderInfo: FC<IHeaderInfo> = ({ companyId, structureId }) => {
  const {
    data,
    isLoading,
    error: structureError,
  } = useFetchStructureData(companyId, structureId!);

  const logStatus = useLogStatus();

  if (structureError) {
    logStatus({
      type: NewRelicLogLevel.ERROR,
      message: "HeaderInfo: fetchStructureData failed",
      statusDetails: {
        source: "API",
        operation: "fetchStructureData",
        status: (structureError as AxiosError)?.response?.status,
        url: (structureError as AxiosError)?.config?.url,
      },
    });
  }

  const visibility = data?.visible;
  const name = data?.name;

  return (
    <>
      <Typography
        variant="h4"
        sx={{ fontWeight: "fontWeightBold", textTransform: "uppercase" }}
      >
        {__("Struktura")} {name}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: "fontWeightMedium",
          textTransform: "uppercase",
          margin: "8px 0",
        }}
      >
        {__("Panel Administracyjny")}
      </Typography>
      <Stack direction="row" sx={{ alignItems: "center", my: 1 }}>
        <LensIcon
          sx={{
            // eslint-disable-next-line no-nested-ternary
            fill: isLoading ? "grey" : visibility ? "green" : "red",
            marginRight: "8px",
          }}
        />
        <Typography>
          {/* eslint-disable-next-line no-nested-ternary */}
          {isLoading
            ? __("Ładowanie")
            : visibility
            ? __("Struktura widoczna")
            : __("Struktura niewidoczna")}
        </Typography>
      </Stack>
    </>
  );
};
export default HeaderInfo;
